<template>
  <label class="tag" :class="{'selected': tag.active}">
    {{label}}
    <input type="checkbox"
      @input="$emit('change',{id: tag.id, to: !tag.active})"
      :checked="tag.active"
      v-show="false"
    >
  </label>
</template>

<script>
export default {
  name: 'TagToggle',
  props: {
    tag: { type: Object, required: true },
  },
  emits: ['change'],
  computed: {
    label(){
      let label = this.tag.label
      if(typeof label === "string" && label.trim().length){
        return label
      }
      return `TAG:${this.tag.id}`
    }
  }
}
</script>

<style lang="css" scoped>
.tag {
  height: 36px;
  display: inline-flex;
  font-weight: 600;
  font-size: 16px;
  border: 1px solid #D7DDDD;
  transition:  background-color 0.2s, border-color 0.2s, color 0.2s;
  align-items: center;
  border-radius: 25px;
  padding-left: 15px;
  padding-right: 15px;
  cursor: pointer;
  padding-top: 2px;
}
.tag.selected {
  color:  white;
  border-color:#E77423;
  background-color: #E77423;
}
</style>
